import './App.css';
import DigiHealthWrapper from './Components/DigiHealthWrapper'

function App() {
  return (
    <div className="App">
      <DigiHealthWrapper/>
    </div>
  );
}

export default App;
